<template>
  <div class="menu menu-mobile">

    <div :class="['menu-list',{'menuslide': showmenu}]">
        <router-link
          v-for="(item, index) in menulist"
          :key="index"
          :to="item.link"
          :class="['menu-link', {active: currLink == index}]" >
          {{item.name}}
        </router-link>
    </div>
    <div class="menu-wraper"></div>

    <div class="logo-box">
      <router-link to="/"><img src="@/assets/img/Logo-AFCwave.png" /></router-link>
    </div>

    <div class="switch-box">
      <a :class="['switch-btn', {showmenu: showmenu}]" href="javascript:void(0)" @click="swicthMenu()">
        <span class="switch1"></span>
        <span class="switch2"></span>
        <span class="switch3"></span>
      </a>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MenuMobile',
  data() {
    return {
      showmenu: false,
      currLink: 0
    };
  },
  computed: {
    menulist(){
      return [{
        name: this.$i18n.t('Layout.Menu.HomePage'),
        link: '/'
      },{
        name: this.$i18n.t('Layout.Menu.Products'),
        link: '/products'
      },{
        name: this.$i18n.t('Layout.Menu.Solutions'),
        link: '/solutions'
      },{
        name: this.$i18n.t('Layout.Menu.WifiDesign'),
        link: '/wifi'
      },{
        name: this.$i18n.t('Layout.Menu.Training'),
        link: '/training'
      },{
        name: this.$i18n.t('Layout.Menu.Resources'),
        link: '/resources'
      },{
        name: this.$i18n.t('Layout.Menu.AboutUs'),
        link: '/aboutus'
      },{
        name: this.$i18n.t('Layout.Menu.Contact'),
        link: '/contact'
      }];
    }
  },
  components: {
  },
  watch: {
    '$route'(v1, v2){
      this.showmenu = false;
      this.currLink = this.getCurrLink();
    }
  },
  methods: {
    swicthMenu: function(){
      this.showmenu = !this.showmenu;
    },
    getCurrLink(){
      let currMenu = localStorage.getItem('currMenu');
      if(currMenu != null){
        return this.menulist.length - (parseInt(currMenu) + 1);
      }
      return 0;
    }
  },
  created(){
    this.currLink = this.getCurrLink();
  }
};
</script>

<style lang="" scoped>
.menu{
  position: fixed;
  top: 40px;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #FFF;
  z-index: 1000;
}

.menu-mobile{
  display: none;
}

.logo-box{
  display: inline-block;
  height: 60px;
  width: 200px;
  float: left;
  position: relative;
}

.logo-box img{
  display: block;
  max-height: 50%;
  position: absolute;
  top: 50%;
  left: 8%;
  transform: translateY(-50%);
}

.switch-box{
  width: 50px;
  height: 60px;
  float: right;
  margin-right: 20px;
}

.switch-btn{
  display: block;
  width: 20px;
  height: 20px;
  margin: 17.5px auto;
  position: relative;
}

.switch-btn .switch1,.switch2,.switch3{
  position: absolute;
  display: inline-block;
  width: 20px;
  height: 3px;
  background-color: #333;
  transition: 0.5s;
}

.switch-btn .switch1{
  top: 20%;
}

.switch-btn .switch2{
  top: 50%;
}

.switch-btn .switch3{
  top: 80%;
}

.showmenu .switch1{
  transform: rotate(45deg);
  top: 50%;
}

.showmenu .switch2{
  display: none;
  top: 50%;
}

.showmenu .switch3{
  top: 50%;
  transform: rotate(-45deg);
}

.menu-wraper{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 60px;
  background-color: #FFF;
  border-bottom: 2px solid #edeeee;
}

.menu-list{
  position: fixed;
  width: 100%;

  top: -40px;
  transform: translateY(-100%);

  background-color: #FFF;
  border-bottom: 2px solid #edeeee;
  transition: 0.5s;
  overflow: hidden;
}

.menu-link{
  display: block;
  width: 100%;
  color: #666;
  font-size: 16px;
  padding: 10px 0;
  text-indent: 16px;
}

.menu-list .active{
  background-color: rgba(127,0,0, 0.8);
  color: #FFF;
}

.menuslide{
  top: 100px;
  transform: translateY(0);
}


@media screen and (max-width: 920px){
  .menu-mobile{
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout/MenuMobile.vue